import {axios} from '../../services/axios';

export default function getACSRegions(companyID) {
    return axios.get(
        `/Services/ACSDirectRouting/Company/${companyID}/Regions/Available`,
    );
}
